import { Button, Text } from 'rebass';
import { space } from 'styled-system';
import { withRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import posed from 'react-pose';
import styled from 'styled-components';

import { StoryContext } from '../../pages/story';
import useEntity from '../hooks/useEntity';

const posedProps = {
  open: { y: '0%' },
  closed: { y: '100%' },
};

const StyledFlex = styled(posed.div(posedProps))`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  ${space};
`;

const CtaBanner = ({ router, on }) => {
  const id = useContext(StoryContext);
  const story = useEntity({ id, type: 'stories' });
  const member = useEntity(story.member);

  return (
    <>
      <StyledFlex pose={on ? 'open' : 'closed'} p={2}>
        <Button
          type="button"
          variant="primary"
          ml="16px"
          onClick={() => {
            window.location.href = `${process.env.appURL}/member/${
              member['share-id']
            }/story_share/${router.query.id}`;
          }}
          css="cursor: pointer;"
        >
          Open App
        </Button>
      </StyledFlex>
    </>
  );
};
CtaBanner.propTypes = {
  on: PropTypes.bool.isRequired,
  router: PropTypes.shape({
    query: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};

export default withRouter(CtaBanner);
